"use strict";

/** Wynik przy formularzu. Komunikaty HTML pochodzą z walidowanej odpowiedzi serwera. */
export const inlineFormResult = class {
  constructor(form) {
    this.form = form;
    this.result = form.querySelector("[data-form-result]");
  }

  loading(status) {
    this.form.setAttribute("aria-busy", String(status));
    this.form.querySelectorAll('[type="submit"]').forEach((button) => {
      button.disabled = status;
    });
    if (status) {
      this.result.textContent = "Sprawdzanie okręgu wyborczego…";
    }
  }

  show(status, messages) {
    this.clear();
    this.result.classList.add(status ? "wybory-form-result--ok" : "wybory-form-result--error");
    (messages || []).forEach((message) => {
      const paragraph = document.createElement("p");
      paragraph.className = `form-msg form-msg--${message.type === "ok" ? "ok" : "error"}`;
      paragraph.innerHTML = message.text;
      this.result.appendChild(paragraph);
    });
  }

  clear() {
    this.result.textContent = "";
    this.result.classList.remove("wybory-form-result--ok", "wybory-form-result--error");
  }
};
